import React, { useState } from "react";
import ArrowDownIcon from "images/icons/down-arrow-dark.inline.svg";
import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";

import Minus from "images/icons/minus.inline.svg";
import Plus from "images/icons/plus.inline.svg";

const Accordion = ({
  title,
  subtitle,
  content,
  controlClassName,
  contentClassName,
  textClassName,
  isCollapse,
  tapClick,
  isArrowDown,
  iconStyle,
  iconContainerClass,
  iconMinusStyleClass,
  iconPlusStyleClass,
  extraContentHeaderClass,
  extraContentHeader = <></>
}) => {
  const [isActive, setIsActive] = useState(isCollapse);
  return (
    <>
      <div
        className={`${controlClassName ?? ""} relative z-10`}
        onClick={() => {
          tapClick();
          setIsActive(!isActive);
        }}
      >
        <div
          className={`flex-1 ${textClassName}`}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={iconContainerClass}>
          {iconStyle === "arrow" && (
            <>
              {isArrowDown ? (
                <ArrowDownIcon
                  className={`stroke-white  transition ease-in-out duration-300 ${
                    isActive ? "rotate-180" : ""
                  }`}
                />
              ) : (
                <ArrowRightIcon
                  className={`stroke-white  transition ease-in-out duration-300 ${
                    isActive ? "rotate-90" : ""
                  } `}
                />
              )}
            </>
          )}

          {iconStyle === "minus" && (
            <>
              {isActive ? (
                <Minus
                  className={`${iconMinusStyleClass} transition ease-in-out duration-300`}
                />
              ) : (
                <Plus
                  className={`${iconPlusStyleClass} transition ease-in-out duration-300`}
                />
              )}
            </>
          )}
        </div>
        {subtitle && isActive && <>{subtitle}</>}
      </div>
      {isActive && (
        <>
          <div className={extraContentHeaderClass}>{extraContentHeader}</div>

          <div
            className={`${
              contentClassName ?? ""
            } transition ease-in-out duration-300 tab-content tab-content_html`}
          >
            {content}
          </div>
        </>
      )}
    </>
  );
};

Accordion.defaultProps = {
  isCollapse: true,
  tapClick: () => {},
  isArrowDown: true,
  iconStyle: "arrow",
  iconContainerClass: "pt-2",
  iconMinusStyleClass: "fill-black-lighter ",
  iconPlusStyleClass: "fill-black-lighter ",
  iconArrowStyleClass: ""
};

export default Accordion;
